import { Card, Title, Accordion, Text } from '@mantine/core';
import { faqData } from '../data/faqData';

const FAQCard = () => {
  return (
    <Card shadow="md" p="xl" radius="lg" withBorder className="modern-card">
      <Title order={3} mb="lg" c="gray.1">
        ❓ Frequently Asked Questions
      </Title>
      <Accordion variant="separated" radius="md">
        {faqData.map((item, index) => (
          <Accordion.Item key={index} value={String(index)}>
            <Accordion.Control>
              <Text fw={500} c="gray.1" size="sm">
                {item.question}
              </Text>
            </Accordion.Control>
            <Accordion.Panel>
              <Text c="gray.3" size="sm" lh={1.7}>
                {item.answer}
              </Text>
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </Card>
  );
};

export default FAQCard;
